module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABBUlEQVQoU42SsQtBURSH3aIMRoNB8Qd4SfkfLFZlpBiUwWqiDDIZDAaLMplQFmWkDAaD0WZgeINiMKjnO7pPBp576+u+987ve9c5nvL9WY7jxIlMIAplpdRUFGUgdsnUdG6PaJmKPYJVLY4R854iP9FPoAUB2EAEhoi3nyJSiOIIZgSH39p59UgwwZaENQShD3UkOenrUkglKgNdvbNvIYd09hqciEcCMmp37ZBSXtKrR8Qru/TkLpsLy+TEJsHGh9jhOqbvZYoLt6Y/hhvPbHc4WYppWPJwJUFCMv4CZGAOMkC5f0DF5MuR/1MGKJN+t/NX1KeH2U8gL5F1MBK1LKe24QLFJ0WrV2kvxZ0YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/pathIcon.png
// module id = Hmza
// module chunks = 0